import * as signalR from '@microsoft/signalr'

class SignalRService {
  constructor() {
    this.connection = null
    this.isConnected = false
    this.callbacks = {
      onAck: null,
      onReplyMsg: null,
      onReplyCompleted: null,
      onError: null,
    }
  }

  // Khởi tạo kết nối SignalR
  async initializeConnection(userId = '') {
    try {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(
          `${process.env.REACT_APP_CHATBOT_CONNECT_URL}/hub/chat?userId=${userId}`,
        )
        .withAutomaticReconnect()
        .build()

      // Đăng ký các event handlers
      this.setupEventHandlers()

      // Bắt đầu kết nối
      await this.connection.start()
      this.isConnected = true

      return true
    } catch (error) {
      this.isConnected = false

      if (this.callbacks.onError) {
        this.callbacks.onError(error)
      }

      return false
    }
  }

  // Thiết lập các event handlers
  setupEventHandlers() {
    if (!this.connection) return

    // Nhận Ack từ server
    this.connection.on('Ack', (ack) => {
      if (this.callbacks.onAck) {
        this.callbacks.onAck(ack)
      }
    })

    // Nhận ReplyMsg từ server
    this.connection.on('ReplyMsg', (replyMsg) => {
      if (this.callbacks.onReplyMsg) {
        this.callbacks.onReplyMsg(replyMsg)
      }
    })

    // Nhận ReplyCompleted từ server
    this.connection.on('ReplyCompleted', (replyMsg) => {
      if (this.callbacks.onReplyCompleted) {
        this.callbacks.onReplyCompleted(replyMsg)
      }
    })

    // Xử lý khi kết nối bị ngắt
    this.connection.onclose((error) => {
      this.isConnected = false
    })

    // Xử lý khi kết nối lại
    this.connection.onreconnecting((error) => {
      console.log('SignalR reconnecting:', error)
      this.isConnected = false
    })

    // Xử lý khi kết nối lại thành công
    this.connection.onreconnected((connectionId) => {
      console.log('SignalR reconnected:', connectionId)
      this.isConnected = true
    })
  }

  // Gửi tin nhắn user
  async sendUserMessage(messageData) {
    if (!this.connection || !this.isConnected) {
      console.error('SignalR connection not available')
      return false
    }

    try {
      await this.connection.invoke('SendUserMessage', messageData)
      return true
    } catch (error) {
      console.error('Failed to send message:', error)
      if (this.callbacks.onError) {
        this.callbacks.onError(error)
      }
      return false
    }
  }

  // Đăng ký callback functions
  onAck(callback) {
    this.callbacks.onAck = callback
  }

  onReplyMsg(callback) {
    this.callbacks.onReplyMsg = callback
  }

  onReplyCompleted(callback) {
    this.callbacks.onReplyCompleted = callback
  }

  onError(callback) {
    this.callbacks.onError = callback
  }

  // Ngắt kết nối
  async disconnect() {
    if (this.connection) {
      await this.connection.stop()
      this.connection = null
      this.isConnected = false
    }
  }

  // Kiểm tra trạng thái kết nối
  getConnectionStatus() {
    return {
      isConnected: this.isConnected,
      connectionState: this.connection?.state || 'Disconnected',
    }
  }
}

// Export singleton instance
export default new SignalRService()
